<ks-plain-gallery
  (show)="onShowModalGallery($event)"
  [accessibilityConfig]="accessibilityConfig"
  [images]="images"
  [plainGalleryConfig]="plainGalleryConfig"
  [showGallery]="showGallery && isPlainGalleryVisible()"
></ks-plain-gallery>

<ks-background
  [accessibilityConfig]="accessibilityConfig"
  [isOpen]="opened"
></ks-background>

<div
  (clickOutside)="onClickOutside($event)"
  *ngIf="opened"
  [attr.aria-label]="accessibilityConfig.modalGalleryContentAriaLabel"
  [clickOutsideEnable]="enableCloseOutside"
  [title]="accessibilityConfig.modalGalleryContentTitle"
  id="modal-gallery-wrapper"
  ksClickOutside
>
  <div id="flex-min-height-ie-fix">
    <div id="modal-gallery-container">
      <ks-upper-buttons
        (close)="onCloseGallery($event)"
        (comments)="onShowComments($event)"
        (customEmit)="onCustomEmit($event)"
        (delete)="onDelete($event)"
        (doubleSpeed)="onDoubleSpeed($event)"
        (download)="onDownload($event)"
        (fullscreen)="onFullScreen($event)"
        (info)="onShowInfo($event)"
        (navigate)="onNavigate($event)"
        (rotate)="onRotate($event)"
        (rotateCss)="onRotateCss($event)"
        [buttonsConfig]="buttonsConfig"
        [currentImage]="currentImage"
      ></ks-upper-buttons>

      <ks-current-image
      (changeImage)="onChangeCurrentImage($event)"
        (close)="onCloseGallery($event)"
        (loadImage)="onImageLoad($event)"
        (longerTask)="longTask($event)"
        (selectImage)="checkboxChange($event)"
        [(isOpenInfoBlock)]="openedInfoBlock"
        [accessibilityConfig]="accessibilityConfig"
        [commentsDataSource]="commentsDataSource"
        [currentImageConfig]="currentImageConfig"
        [currentImage]="currentImage"
        [id]="id"
        [images]="images"
        [infoBlockContent]="infoBlockContent"
        [infoTemplate]="infoTemplate"
        [isCheckable]="isCheckable"
        [isOpen]="opened"
        [keyboardConfig]="keyboardConfig"
        [selectedImages]="selectedImages"
        [slideConfig]="configSlide"
        [user]="user"

      ></ks-current-image>

      <div>
        <ks-dots
          (clickDot)="onClickDot($event)"
          [accessibilityConfig]="accessibilityConfig"
          [currentImage]="currentImage"
          [dotsConfig]="dotsConfig"
          [images]="images"
        ></ks-dots>

        <ks-previews
          (clickPreview)="onClickPreview($event)"
          [accessibilityConfig]="accessibilityConfig"
          [currentImage]="currentImage"
          [images]="images"
          [previewConfig]="previewConfig"
        ></ks-previews>
      </div>
    </div>
  </div>
</div>
